import React, { useState } from "react";

import { Button, Grid, SvgIcon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  tile: {
    height: "80px",
    backgroundColor: "#FFF",
    textAlign: "center",
    width: "80%",
    cursor: "pointer",
    color: "#393939",
    padding: "5%",
    border: "#67729429",
    "&:hover": {
      backgroundColor: "#3f51b5",
      color: "#F5F7FA",
    },
  },
  analyticwindow: {
    backgroundColor: "#F5F7FA",
    color: "#393939",
    width: "300px",
  },
  button: {
    marginRight: "5px",
    borderRadius: "10px",
  },
});
export default function ViewSalesReports() {
  let history = useHistory();
  let match = useRouteMatch();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [salesList, setSalesList] = useState([
    {
      id: 0,
      name: "Location Specfic prospect Count",
      link: "viewcdtreports",
    },
    {
      id: 1,
      name: "Prospect Flow",
      link: "viewcdtreports",
    },
    {
      id: 2,
      name: "Revenue Tracker",
      link: "viewcdtreports",
    },
    {
      id: 3,
      name: "Referral Data",
      link: "viewcdtreports",
    },
    {
      id: 4,
      name: "First call after payment",
      link: "viewcdtreports",
    },
    // {
    //     id: 5,
    //     name: "Onboarding completion",
    //     link: "viewcdtreports"

    // },
    {
      id: 5,
      name: "Prospect Age",
      link: "viewcdtreports",
    },
    // {
    //     id: 7,
    //     name: "Investor Age",
    //     link: "viewcdtreports"

    // },
    // {
    //     id: 8,
    //     name: "Days To Renewal",
    //     link: "viewcdtreports"
    // },
    // {
    //     id: 9,
    //     name: "Inactive Period",
    //     link: "viewcdtreports"
    // }
    {
      id: 6,
      name: "Client Conversion Report",
      link: "viewcdtreports",
    },
    {
      id: 7,
      name: "Payment Links",
      link: "viewcdtreports",
    },
  ]);
  const classes = useStyles();

  const handleListItemClick = (event, index, menuObject) => {
    if (menuObject.link) {
      history.push({
        pathname: menuObject.link,
        state: index,
        name: menuObject.id,
        cardName: menuObject.name,
      });

      // history.push(menuObject.link);
    } else {
      history.push(`${match.url}`);
    }
  };
  return (
    <>
      <Grid container style={{ marginTop: "20px" }} className={"prospectgrids"}>
        {salesList.map((e, index) => {
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={index}
              selected={selectedIndex === index}
              onClick={(event) => handleListItemClick(event, index, e)}
            >
              <Paper className={classes.tile}>
                <Typography variant="h6" style={{ fontSize: "1.05rem" }}>
                  {e.name}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
